export class PageNotFoundLabelEN {

    notFound: string;
    redirect: string;
    home: string;

    constructor() {
        this.notFound = "The page you have requested has not found.";
        this.redirect = "Do you want to Redirect to home?";
        this.home = "Click Here";
    }
}
